import React from 'react'
import firebase from './firebase'
import cookie from 'react-cookies'
import { API_ENDPOINT } from './AppConfig'
import axios from 'axios'
import ReactNotification from 'react-notifications-component'
import { store } from 'react-notifications-component';
import {Link} from 'react-router-dom'
import 'react-notifications-component/dist/theme.css'

const messaging = firebase.messaging()

class FirebaseComponent extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      allNotifications: []
    }
  }

  componentDidMount() {

    // askForPermissioToReceiveNotifications()
    messaging.requestPermission().then(() => {
      return messaging.getToken()
    }).then(token => {
      console.log('Token Response: ', token)
      // addToken(token)
      cookie.save("NotificationToken", token, { path: '/' })
    }).catch((err) => {
      console.log('Token error: ', err);
    })

    let token_cookie = cookie.load("HB_token");
    let token_sessionStorage = sessionStorage.getItem("HB_token");
    if (token_cookie !== undefined && (JSON.stringify(token_sessionStorage) !== "null" || JSON.stringify(token_sessionStorage) !== null)) {
      let NotifiToken = cookie.load("NotificationToken")
      console.log('NotifiToken-> ', NotifiToken)
      this.addToken(NotifiToken)
    }
    messaging.onMessage((payload) => {
      console.log("Token Response:===>", payload);
      store.addNotification({
        title: "Health Book",
        message: payload.data.message,
        type: "warning",
        insert: "top",
        container: "bottom-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 5000,
          onScreen: true
        },
      });
      // let temp = this.state.allNotifications
      // temp.push(payload.data)
      // this.setState({
      //   allNotifications: temp
      // })
    })
  }
  addToken = (tokenid) => {
    let token_cookie = cookie.load("HB_token");
    let token_sessionStorage = sessionStorage.getItem("HB_token");
    let token = `Bearer ${token_cookie ? token_cookie : JSON.parse(token_sessionStorage)}`
    console.log('token000--> ', token)
    let data = {
      token: tokenid,
      type: "web"
    }
    axios.post(`${API_ENDPOINT}/addToken`, data, {
      headers: {
        'Content-Type': "application/json",
        Authorization: token
      }
    }).then(response => {
      console.log('Token Response data==> ', response.data.user)

    }).catch(error => {
      console.log('TToken Response==>error ', error.response)
    })
  }
 

  render() {

    return (
      <div>
      <Link to="/HealthBook-Web/Notifications">
        <ReactNotification />
      </Link>
      </div>
    )
  }
}

export default FirebaseComponent;
